export default __webpack_public_path__ + "static/media/avatar_merlion2.0cd00c7d.mp3";